<template>
    <div>
        <div class="search-box">
            <div class="location">
                <span>您的当前位置：</span>
                <span
                    >首页&lt;{{ $route.query.type == 1 ? "课程搜索" : "资讯"
                    }}{{
                        $route.query.str ? "&lt;" + $route.query.str : ""
                    }}</span
                >
            </div>
            <!-- 视频课程 -->
            <div v-show="$route.query.type == 1" class="content-box flex-row">
                <div
                    v-for="(item, index) in videoList"
                    :key="index"
                    class="video-box"
                    @click="goDetails(item)"
                >
                    <div class="video-img flex-col scale-box">
                        <img :src="item.cover" :alt="item.totalTitle" />
                    </div>
                    <div class="video-title">
                        {{ item.totalTitle }}
                    </div>
                    <div class="video-time-view flex-row">
                        <span>讲师：{{ item.teacherName }}</span>
                        <span>浏览量:{{ item.popularity }}</span>
                    </div>
                </div>
            </div>
            <!-- 资讯 -->
            <div class="zixun-box flex-row" v-show="$route.query.type == 2">
                <div
                    v-for="(item, index) in zixunList"
                    :key="index"
                    class="zixun-item"
                >
                    <div
                        @click="goArticalDetail(item)"
                        class="zixun-item-img bg scale-box"
                    >
                        <img :src="item.image" :alt="item.title" />
                    </div>
                    <div class="zixun-item-content">
                        <h2>{{ item.title }}</h2>
                        <p class="tips">
                            <span>{{ item.creaTime.time | dateFormat }}</span>
                            <span>浏览次数：{{ item.popularity }}</span>
                        </p>
                        <p class="intro">
                            {{
                                item.introduction &&
                                item.introduction.length > 80
                                    ? item.introduction.substring(0, 80) + "..."
                                    : item.introduction
                            }}
                            <span
                                class="view-more"
                                @click="goArticalDetail(item)"
                                >&lt;查看更多&gt;</span
                            >
                        </p>
                    </div>
                </div>
            </div>
            <pagebreak
                :totalPage="pageData.totalPage"
                @changePage="changePage"
            ></pagebreak>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            videoList: [],
            zixunList: [],
            pageData: {
                totalPage: 1
            }
        };
    },
    created() {
        if (this.$route.query.type) {
            this.getSearchData();
        }
    },
    methods: {
        //课程详情
        goDetails(item) {
            this.$router.push({
                name: "classDetails",
                query: { id: item.id, t1: "在线课程" }
            });
        },
        getSearchData(page = 1) {
            this.$ajax({
                url: "homePage/mySearch",
                method: "post",
                data: {
                    type: this.$route.query.type.toString(),
                    content: this.$route.query.str,
                    current: page
                },
                success: res => {
                    if (res.code == 200) {
                        if (parseInt(this.$route.query.type) == 1) {
                            this.videoList = res.message.records;
                            this.pageData.totalPage = Math.ceil(
                                res.message.total / res.message.size
                            );
                        } else {
                            this.zixunList = res.message.records;
                            this.pageData.totalPage = Math.ceil(
                                res.message.total / res.message.size
                            );
                        }
                    }
                },
                error: () => {}
            });
        },
        changePage(index) {
            this.getSearchData(index);
        },
        goArticalDetail(item) {
            this.$router.push({
                name: "artDetail",
                query: {
                    id: item.id,
                    t1: "首页",
                    t2: "资讯"
                }
            });
        }
    },
    watch: {
        "$route.query": function(nval) {
            this.getSearchData();
        }
    }
};
</script>

<style lang="scss" scoped>
.search-box {
    width: 1000px;
    margin: 0 auto;
    min-height: 600px;
    .location {
        height: 40px;
        color: #999;
    }
    .content-box {
        width: 1000px;
        min-height: 500px;
        align-items: flex-start;
        align-content: flex-start;
        .video-box {
            width: 242.5px;
            display: inline-block;
            margin-top: 10px;
            box-sizing: border-box;
            margin-right: 10px;
            font-size: 16px;
        }

        .video-box:nth-child(4n) {
            margin-right: 0;
        }

        .video-img {
            width: 100%;
            height: 164.9px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            box-sizing: border-box;
            overflow: hidden;
            img {
                min-height: 100%;
                width: 100%;
            }
        }

        .video-title {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 5px;
        }

        .video-time-view {
            justify-content: space-between;
            span {
                vertical-align: middle;
            }
        }
    }
    // 资讯
    .zixun-box {
        margin-top: 20px;
        min-height: 500px;
        align-items: flex-start;
        align-content: flex-start;
        .zixun-item {
            margin-right: 35px;
            margin-bottom: 20px;
            font-size: 14px;
            .zixun-item-img {
                display: inline-block;
                vertical-align: top;
                height: 164px;
                width: 242px;
                border: 1px solid #ddd;
                box-sizing: border-box;
                overflow: hidden;
                img {
                    width: 100%;
                    min-height: 100%;
                }
            }
            .zixun-item-content {
                display: inline-block;
                vertical-align: top;
                margin-left: 6px;
                width: 230px;
                height: 164px;
                h2 {
                    padding: 5px 0;
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: bold;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .tips {
                    line-height: 20px;
                    color: #666;
                    span:nth-child(1) {
                        margin-right: 20px;
                    }
                }
                .intro {
                    margin-top: 5px;
                    line-height: 18px;
                    height: 90px;
                    overflow: hidden;
                    position: relative;
                    word-break: break-all;
                }
                .view-more {
                    display: inline-block;
                    height: 18px;
                    line-height: 18px;
                    color: #3366cc;
                    background-color: #fff;
                    cursor: pointer;
                }
            }
        }
        .zixun-item:nth-child(2n) {
            margin-right: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/search/search.vue